// Integration Method
export enum IntegrationMethod {
  inline = 'inline', // Inline Frame
  link = 'link', // Link
}
